import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';

const blue = '#0d4efe';

export const AdminPageOuter = styled(Box)(() => ({
  minHeight: 'calc(100vh - 120px)',
  backgroundColor: '#fff',
}));

export const AdminSidebarContainer = styled(Box)(() => ({
  width: 280,
  flexShrink: 0,
  backgroundColor: '#fff',
  borderRight: '1px solid #e0e0e0',
  padding: '16px 12px',

  '@media (max-width: 960px)': {
    width: '100%',
    borderRight: 'none',
    borderBottom: '1px solid #e0e0e0',
    padding: '12px 16px',
  },
}));

export const AdminHeaderBand = styled(Box)(() => ({
  padding: '24px 28px',
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.1)',
  borderRadius: 16,
  marginBottom: 24,
}));

export const AdminPageTitle = styled(Typography)(() => ({
  fontFamily: "'Exo 2', sans-serif",
  fontWeight: 700,
  color: '#1a1a2e',
  marginBottom: 4,
}));

export const AdminSectionTitle = styled(Typography)(() => ({
  fontFamily: "'Exo 2', sans-serif",
  fontWeight: 700,
  color: '#1a1a2e',
  marginBottom: 20,
}));

export const AdminListSection = styled(Box)(() => ({
  padding: '0 0 16px',
}));

export const AdminBusinessNameButton = styled(ButtonBase)(() => ({
  fontWeight: 600,
  color: '#1a1a2e',
  minWidth: 0,
  textAlign: 'left',
  justifyContent: 'flex-start',
  borderRadius: 8,
  padding: '2px 6px',
  margin: '-2px -6px',
  transition: 'color 0.15s ease, background 0.15s ease',
  '&:hover': {
    color: blue,
    background: 'rgba(13, 78, 254, 0.06)',
  },
  '&:focus-visible': {
    outline: `2px solid ${blue}`,
    outlineOffset: 2,
  },
}));

export const AdminGooglePlaceIcon = styled('img')({
  height: 14,
  width: 'auto',
  display: 'block',
  flexShrink: 0,
});
